import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {Api} from "../../services/api";

/**
 * Generated class for the WeixinPayOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var WeixinJSBridge;

@IonicPage(
  {
    segment: "weixin-pay-order/:id"
  }
)
@Component({
  selector: 'page-weixin-pay-order',
  templateUrl: 'weixin-pay-order.html',
})
export class WeixinPayOrderPage {

  data = {
    order: null,
    orderPaid: false,
  };

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public api: Api,
              public loadingCtrl: LoadingController,
  ) {
  }

  ionViewDidEnter() {
    document.title = "订单支付";
    this.api.weixinPayOrder(this.navParams.data.id).then((orderInfo) => {
      this.data.order = orderInfo;

      const onWeixinPayOk = () => {
        let loading = this.loadingCtrl.create({
          content: "正在查询订单状态",
        });
        loading.present();
        let orderResolved = false;
        let intervalId = setInterval(() => {
          this.api.getOrderState(this.navParams.data.id).then((_) => {
            if (orderResolved) {
              return;
            }
            if (_.stage === 1) {
              orderResolved = true;
              clearInterval(intervalId);
              loading.dismiss();

              this.data.orderPaid = true;

            }
          });
        }, 1000);
      };

      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          orderInfo,
          function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              onWeixinPayOk();
            } else {
              alert(res.err_msg);
            }
          }
        );
      }

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        }
      } else {
        onBridgeReady();
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/weixin-pay-order/weixin-pay-order.ts